import { Component, OnInit, Input, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { Case } from '../../../../shared/models/case';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { AttentionsFacade } from 'src/app/abstraction/attentions.facade';
import { NgZone } from '@angular/core';
import { AttentionsService } from '../../../../core/services/attentions.service';
import { EvolutionsFacade } from '../../../../abstraction/evolutions.facade';
import { ProvisionAgreementFilters } from '../../../../shared/models/ProvisionAgreementFilters';
import { Subscription, take } from 'rxjs';
import { CaseDateFilters, CasesFacade } from 'src/app/abstraction/cases.facade';
import { ProvisionsFacade } from 'src/app/abstraction/provisions.facade';
import { Attention } from '../../../../shared/models/attention';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { Router } from '@angular/router';
import { ROUTES } from 'src/app/core/enums/routes';
import moment from 'moment';
import { Provision } from 'src/app/shared/models/provision';
import { OrdersQPS } from 'src/app/core/services/cases.service';
import { Order } from 'src/app/shared/models/order';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { event } from 'jquery';
import { ViewManagementEntities } from 'src/app/core/enums/ViewManagementEntities';
import { ModulesFacade } from 'src/app/abstraction/modules.facade';
// import { CaseModule, CaseModuleComposed, Module } from 'src/app/shared/models/module';
// import { modulesGetQPS } from 'src/app/shared/models/modulesQPS';
import { ProvisionFeeWithPractice } from 'src/app/shared/models/submodels/provisionFeeWithPractice';
import { log } from 'console';
import { ProvisionsService } from 'src/app/core/services/provisions.service';

export enum OPTIONS {
    SUPPLY = "SUPPLY",
    PROVISION = "PROVISION",
    ORDER = "ORDER",
    MODULE = "MODULE"
}

@Component({
    selector: 'app-provision-scheme',
    templateUrl: './provision-scheme.component.html',
    styleUrls: ['./provision-scheme.component.scss']
})
export class ProvisionSchemeComponent implements OnInit {
    @Input() data: { name: string; surname: string; typeDocument: string, document: string; cif: number; };
    @Input("case") case: Case;
    @Input("attentionsCaseActive") attentionsCaseActive: Attention[];

    _screenToJumpSubscription: Subscription
    public readonly options: OPTIONS;
    selectedOption: OPTIONS = OPTIONS.PROVISION;
    selected1: OPTIONS = OPTIONS.ORDER
    visibleEvolution: boolean = false;
    swalWithCustomizeButtons: any;
    // caseModulesComposed: CaseModuleComposed[] = [];
    showScheduleList: boolean = false;
    expandedProvision = null;
    // selectedCaseModuleIds: number[] = [];
    refresh = false;
    visibleCalendarPanel: boolean = false;
    isCollapsedView: boolean = false;
    viewColumnsBillAndDebit: boolean = false;
    /** Fecha que se actualiza cada vez que cambia el modo de vista → dispara resetChecks en modules-scheme */
    // modulesResetDate: Date | null = null;
    private _scheduleViewMode: string = 'calendario';
    get scheduleViewMode(): string { return this._scheduleViewMode; }
    set scheduleViewMode(value: string) {
        this._scheduleViewMode = value;
    }
    _filtersOnProvision: Subscription;
    provisionAgreementsFilters: ProvisionAgreementFilters;
    // _allProvisionsInCaseModules: Provision[] = [];
    // get allProvisionsInCaseModules(): Provision[] {
    //     return this._allProvisionsInCaseModules;
    // }
    // set allProvisionsInCaseModules(value: Provision[]) {
    //     this._allProvisionsInCaseModules = value;
    //     this.castModules()
    // }
    provisionsFilteredCount: number = 0;
    provisionsSuppliesFilteredCount: number = 0;
    ordersFilteredCount: number = 0;
    modulesFilteredCount: number = 0;
    _isLoadingGetAttentions: Subscription;
    _isLoadingGettingEvolutions: Subscription;
    isLoadingGetAttentions: boolean;
    isLoadingGettingEvolutions: boolean;
    showCalendarList: boolean = false;
    _historyModeDate: Subscription;
    dateRange: CaseDateFilters;
    jumpToScreen: boolean = false;
    historyFromDate: Date;
    historyToDate: Date;
    isAdmin: boolean = false;
    provisionsFeeIdsToModifySupplies: number[]; // provisionFee Ids
    billModifiedSupplies: number[];
    _allProvisions: Subscription;
    // _caseModules: Subscription;
    allProvisionsWithoutFilter: Provision[]; // ALL Provisions without filetrs to case
    allProvisionsFull: Provision[]; // Full copy (including module-linked fees) used to restore provisionsDisplayedOnScreen$ on tab switch
    _allOrders: Subscription;
    allOrders: Order[];
    attentions: Attention[];
    execute: boolean = false;
    provisionFeesWithPractices: ProvisionFeeWithPractice[] = null;

    // singleSelectedCaseModule: { id: number | null, name: string | null } = { id: null, name: null };
    ordersRadioSelected: boolean = false;
    // Getter para saber si activar modo single (solo en modo listado dentro de agenda o modo facturar):
    // get isModuleSingleSelectionMode(): boolean {
    //     // Radio button cuando: es MODULOS + (agenda visible + modo 'listado' O modo facturar)
    //     return this.isModule() && (
    //         (this.visibleCalendarPanel && this.scheduleViewMode === 'listado') ||
    //         this.viewColumnsBillAndDebit
    //     );
    // }

    constructor(
        private cd: ChangeDetectorRef,
        public dialog: MatDialog,
        private attentionsFacade: AttentionsFacade,
        private evolutionsFacade: EvolutionsFacade,
        private casesFacade: CasesFacade,
        private provisionsFacade: ProvisionsFacade,
        private attentionsService: AttentionsService,
        private ngZone: NgZone,
        private authenticationService: AuthenticationService,
        private breadcrumbService: BreadcrumbService,
        private router: Router,
        // private modulesFacade: ModulesFacade,
        private provisionsService: ProvisionsService,
    ) { }

    ngOnInit(): void {

        this._screenToJumpSubscription = this.breadcrumbService.getScreenToJump$().subscribe(event => {
            this.handleEvent(event)
        })

        const currentRange = this.casesFacade.getCaseDateFilter();
        this.historyFromDate = currentRange?.historyFromDate;
        this.historyToDate = currentRange?.historyToDate;

        // Load orders with active history range to avoid fetching unnecessary rows.
        this.loadOrdersForCurrentCase(currentRange);

        this.isAdmin = this.authenticationService.isAdmin();

        this.swalWithCustomizeButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btnSwalConfirm',
                cancelButton: 'btnSwalCancel'
            },
            buttonsStyling: true
        })

        this.subscribeToData();
    }

    ngOnDestroy() {
        this._screenToJumpSubscription.unsubscribe();
        this.breadcrumbService.setScreenToJump(null)

        if (!!this._filtersOnProvision) {
            this._filtersOnProvision.unsubscribe();
        }
        this.provisionsFacade.setFiltersOnProvisions(null);
        if (this._isLoadingGetAttentions) {
            this._isLoadingGetAttentions.unsubscribe();
        }
        if (this._isLoadingGettingEvolutions) {
            this._isLoadingGettingEvolutions.unsubscribe();
        }
        !!this._historyModeDate ? this._historyModeDate.unsubscribe() : null;
        !!this._allProvisions ? this._allProvisions.unsubscribe() : null;
        !!this._allOrders ? this._allOrders.unsubscribe() : null;
        // !!this._caseModules ? this._caseModules.unsubscribe() : null;
    }

    subscribeToData() {

        // Spinner control
        this._isLoadingGetAttentions = this.attentionsFacade.isLoadingGetAttentions$().subscribe(loadingAttentions => {
            this.isLoadingGetAttentions = loadingAttentions;
            this.attentions = this.attentionsFacade.getAttentionsCaseActive();
        });
        this._isLoadingGettingEvolutions = this.evolutionsFacade.isLoadingGetEvolutions$().subscribe(loadingEvolutions => this.isLoadingGettingEvolutions = loadingEvolutions);
        this.suscribeToFilters();

        this._allOrders = this.casesFacade.getOrders$().subscribe(orders => {
            if (!!orders) {
                this.allOrders = orders;
                this.casesFacade.filterOrdersOnDateFilters(this.allOrders);
            }
        })

        this._historyModeDate = this.casesFacade.getCaseDateFilters$().subscribe(dateRange => {
            if (!!dateRange) {
                this.dateRange = dateRange;
                if (this.historyFromDate !== dateRange.historyFromDate || this.historyToDate !== dateRange.historyToDate) {
                    // this.loadOrdersForCurrentCase(dateRange);
                    this.removeFilters();
                }

                this.historyFromDate = dateRange.historyFromDate;
                this.historyToDate = dateRange.historyToDate;

                if (this.execute) {
                    this.provisionsFacade.filterProvisionsOnDateFilters(this.allProvisionsWithoutFilter); // Set provisionsToDisplayedOnScreen
                    this.casesFacade.filterOrdersOnDateFilters(this.allOrders);
                }
            }
        })

        // Provisions: suscribirse al state SOLO cuando loadAllProvisionsForCase haya terminado
        this.provisionsFacade.loadAllProvisionsForCase(this.case.id).subscribe({
            next: () => {
                this._allProvisions = this.provisionsFacade.getAllProvisionsCase$().subscribe(allProvisions => {
                    if (!!allProvisions) {
                        this.allProvisionsWithoutFilter = allProvisions;
                        this.allProvisionsFull = JSON.parse(JSON.stringify(allProvisions)); // keep full copy for restoring after leaving Module tab
                        this.execute = true;
                        this.casesFacade.setCaseDateFilters(this.casesFacade.getCaseDateFilter()); // Force load this._historyModeDate
                        this.allProvisionsWithoutFilter = [...this.provisionsService.getProvisionsWithoutCaseModulesId(JSON.parse(JSON.stringify(allProvisions)))];
                        // Alimentar provisionsDisplayedOnScreen$ para que provisions-detail muestre la tabla de prácticas
                        this.provisionsFacade.filterProvisionsOnDateFilters(this.allProvisionsWithoutFilter);
                        // this.allProvisionsInCaseModules = [...this.provisionsService.getProvisionsWithCaseModulesId(JSON.parse(JSON.stringify(allProvisions)))];
                        // Rebuild caseModulesComposed con provisions actualizadas (incluye specialtyId del GET)
                        // this.castModules();
                    }
                });
            },
            error: (e) => console.error('Error loading all provisions for case:', e),
        });

        // CaseModules: subscribe to state so UI refreshes when facade updates the store (e.g. post/patch).
        // this._caseModules = this.modulesFacade.getCaseModules$().subscribe(caseModules => {
        //     this.caseModules = caseModules ?? [];
        //     this.castModules();
        // });

        // Trigger initial load (and future manual refreshes can still call loadCaseModules$)
        // this.modulesFacade.loadCaseModules$(this.case.id).subscribe();

        //MODULES

        // this.getmodulesQPS.financierId = this.case.financierId;
        // this.modulesFacade.loadModuleByCode$(this.getmodulesQPS)
        //     .subscribe(async (moduleToUpdate) => {
        //         this.modulesFilteredByFinancier = moduleToUpdate.data
        //     })
    }

    private loadOrdersForCurrentCase(dateRange?: CaseDateFilters): void {
        const rangeToLoad = (dateRange?.historyFromDate && dateRange?.historyToDate)
            ? this.attentionsService.getPeriodToLoadAttentions(dateRange.historyFromDate, dateRange.historyToDate)
            : null;

        const ordersQPS: OrdersQPS = {
            page: 0,
            size: 1000,
            fromDate: rangeToLoad?.historyFromDate,
            toDate: rangeToLoad?.historyToDate,
        };

        this.casesFacade.loadOrders(ordersQPS, this.case.id);
    }

    // castModules() {
    //     const ready =
    //         (this.caseModules?.length ?? 0) > 0 &&
    //         (this.modulesFilteredByFinancier?.length ?? 0) > 0;

    //     if (!ready) return;

    //     this.caseModulesComposed = [...this.castCaseModulesAndProvisionsToModules()];
    //     this.provisionFeesWithPractices = null;
    //     // this.caseModulesProvisionFeesWithPractices = this.getCaseModulesProvisionFeesWithPractices();
    // }

    // refreshCaseModulesAfterAdd(): void {
    //     this.modulesFacade
    //         .loadCaseModules$(this.case.id)
    //         .pipe(take(1))
    //         .subscribe(caseModules => {
    //             this.caseModules = caseModules ?? [];
    //             this.castModules();
    //         });
    //     this.provisionsFacade.loadAllProvisionsForCase(this.case.id);
    // }

    onTabChanged(e) {
        // console.log(e);
        setTimeout(() => {
            this.refresh = !this.refresh;
            this.cd.detectChanges();
        }, 100);
    }

    onSelectOption(option: string) {
        // const wasModule = this.selectedOption === OPTIONS.MODULE;
        this.selectedOption = OPTIONS[option];
        // When leaving modules flow, reset selection so attentions-list shows noAttentions template
        // if (wasModule && this.selectedOption !== OPTIONS.MODULE) {
        //     this.singleSelectedCaseModule = { id: null, name: null };
        //     this.ordersRadioSelected = false;
        // }
        // When changing views, remove any filters so the next view starts clean.
        // This prevents previously-applied filters (including transient convention
        // flags like `onlyEntregaInsumos`/`notManageable`) from persisting and
        // causing an emptied attentions list in the new view.
        this.removeFilters();
        // When leaving modules, restore provisionsDisplayedOnScreen$ with the full provisions so that
        // supply-list (or any other component) receives correct data when it subscribes.
        // if (wasModule && this.execute && (this.allProvisionsFull?.length ?? 0) > 0) {
        //     this.provisionsFacade.filterProvisionsOnDateFilters(this.allProvisionsFull);
        // }
    }

    onFlowSelectOption(option: string) {
        // const wasModule = this.selectedOption === OPTIONS.MODULE;
        // this.selectedOption = OPTIONS[option];
        // // When leaving modules flow, reset selection so attentions-list shows noAttentions template
        // if (wasModule && this.selectedOption !== OPTIONS.MODULE) {
        //     this.singleSelectedCaseModule = { id: null, name: null };
        //     this.ordersRadioSelected = false;
        // }
        // Reset filters when navigating programmatically between flows so the
        // destination view is not affected by filters from the previous one.
        this.removeFilters();
        // When leaving modules, restore provisionsDisplayedOnScreen$ with full provisions.
        // if (wasModule && this.execute && (this.allProvisionsFull?.length ?? 0) > 0) {
        //     this.provisionsFacade.filterProvisionsOnDateFilters(this.allProvisionsFull);
        // }
    }

    isProvision(): boolean {
        return this.selectedOption === OPTIONS.PROVISION;
    }

    // isModule(): boolean {
    //     return this.selectedOption === OPTIONS.MODULE;
    // }

    isSupply(): boolean {
        return this.selectedOption === OPTIONS.SUPPLY;
    }

    isOrder(): boolean {
        return this.selectedOption === OPTIONS.ORDER;
    }

    goToScreen(event: ViewManagementEntities) {
        this.breadcrumbService.setScreenToJump(event)
    }
    onClickCalendar() {
        this.jumpToScreen = null
        this.visibleCalendarPanel = true;
        this.visibleEvolution = false;
        this.isCollapsedView = true;
        this.viewColumnsBillAndDebit = false;
        this.scheduleViewMode = 'calendario'; // Inicia en modo calendario
        //console.debug('[ProvisionScheme] onClickCalendar - selectedOption:', this.selectedOption, 'current filters:', this.provisionAgreementsFilters);
        // When opening the calendar we want the displayed attentions to follow the
        // meaning of the currently selected flow:
        // - If we're on ORDER (Pedidos) show only 'Entrega insumos' attentions
        // - If we're on PROVISION (Prestaciones) show only non-supply attentions (isSupply === false)
        // - If we're on SUPPLY we convert view to ORDER so calendar shows the 'Entrega insumos' items
        if (this.selectedOption == OPTIONS.SUPPLY) {
            // Switch to ORDER view so calendar displays orders (Entrega insumos)
            this.onSelectOption('ORDER');
        } else if (this.selectedOption == OPTIONS.ORDER) {
            // Build a filter that instructs the attentions service to show only
            // attentions whose practice.name === 'Entrega insumos'
            if (!this.provisionAgreementsFilters) {
                this.provisionAgreementsFilters = {} as ProvisionAgreementFilters;
            }
            // Use a convention property `onlyEntregaInsumos` for the mamushkaCheckBoxes
            // to interpret and filter by practice.name === 'Entrega insumos'.
            (this.provisionAgreementsFilters as any).onlyEntregaInsumos = true;
            this.provisionsFacade.setFiltersOnProvisions(this.provisionAgreementsFilters);
            this.onFilterAttentions(this.provisionAgreementsFilters);
        } else if (this.selectedOption == OPTIONS.PROVISION) {
            // Show Prestaciones -> attentions with isSupply === false
            if (!this.provisionAgreementsFilters) {
                this.provisionAgreementsFilters = {} as ProvisionAgreementFilters;
            }
            (this.provisionAgreementsFilters as any).onlyNonSupply = true;
            this.provisionsFacade.setFiltersOnProvisions(this.provisionAgreementsFilters);
            this.onFilterAttentions(this.provisionAgreementsFilters);
        }
        // else if (this.selectedOption == OPTIONS.MODULE) {
        //     // Restaurar filtros del flujo módulos para que el calendario muestre todas las atenciones
        //     if (!this.provisionAgreementsFilters) {
        //         this.provisionAgreementsFilters = {} as ProvisionAgreementFilters;
        //     }
        //     this.provisionAgreementsFilters.modulesFlow = true;
        //     this.provisionAgreementsFilters.singleMode = false;
        //     // Limpiar flags residuales de facturar
        //     delete (this.provisionAgreementsFilters as any).notManageable;
        //     this.provisionsFacade.setFiltersOnProvisions(this.provisionAgreementsFilters);
        //     this.onFilterAttentions(this.provisionAgreementsFilters);
        // }
    }

    closePanel() {
        this.visibleCalendarPanel = false;
        this.visibleEvolution = false;
        this.isCollapsedView = false;
        this.viewColumnsBillAndDebit = false;
        this.scheduleViewMode = 'calendario'; // Reset al salir de agenda
        if (this.selectedOption === OPTIONS.ORDER) {
            this.onSelectOption('SUPPLY')
        }
    }

    onClickEvolutions() {
        this.visibleCalendarPanel = false;
        this.visibleEvolution = true;
        this.isCollapsedView = true;
        this.viewColumnsBillAndDebit = false;
        this.scheduleViewMode = 'calendario'; // Reset al cambiar de vista
        if (this.selectedOption == OPTIONS.SUPPLY) {
            this.onSelectOption('ORDER')
        }
    }

    onClickBilling() {
        this.visibleCalendarPanel = false;
        this.visibleEvolution = false;
        this.isCollapsedView = true;
        this.viewColumnsBillAndDebit = true;
        this.scheduleViewMode = 'calendario'; // Reset al cambiar de vista
        if (this.selectedOption == OPTIONS.ORDER) {
            this.onSelectOption('SUPPLY')
        }

        // If we're currently showing SUPPLY, apply a filter to show only
        // supplies that are not manageable (notManageable === true) so the
        // schedule/list shows the items to be billed.
        if (this.selectedOption == OPTIONS.SUPPLY) {
            // Ensure we have a filters object
            if (!this.provisionAgreementsFilters) {
                this.provisionAgreementsFilters = {} as ProvisionAgreementFilters;
            }

            // Add a filter flag that mamushkaCheckBoxes / attentionsFacade can interpret
            // Note: the existing filter structure uses provision/agreement ids; to avoid
            // changing global filter shape, attach a convention property `notManageable`
            // which the `attentionsService.mamushkaCheckBoxes` should respect.
            (this.provisionAgreementsFilters as any).notManageable = true;

            // Update the facade filters so other parts of the UI react
            this.provisionsFacade.setFiltersOnProvisions(this.provisionAgreementsFilters);

            // Trigger attentions filtering using current filters
            this.onFilterAttentions(this.provisionAgreementsFilters);
        }

        // if(this.selectedOption == OPTIONS.MODULE){
        //     // En el caso de módulos, al hacer click en facturar, aplicamos un filtro para mostrar solo los módulos seleccionados (caseModuleIds)
        //     if (!this.provisionAgreementsFilters) {
        //         this.provisionAgreementsFilters = {} as ProvisionAgreementFilters;
        //     }
        //     this.provisionAgreementsFilters.modulesFlow = true;
        //     this.provisionAgreementsFilters.caseModuleIds = [];
        //     this.provisionAgreementsFilters.singleMode = true; // Forzar singleMode en módulo para que al facturar se muestre el mensaje de "Seleccioná un módulo"
        //     this.provisionsFacade.setFiltersOnProvisions(this.provisionAgreementsFilters);
        // }
    }

    receiveAgreementOfNewAttention(agrObject) {
        if (!this.provisionAgreementsFilters?.provisions?.includes(agrObject.agreement.provision)) {
            !!this.provisionAgreementsFilters.provisions
                ?
                this.provisionAgreementsFilters.provisions.push(agrObject.agreement.provision)
                :
                this.provisionAgreementsFilters.provisions = [agrObject.agreement.provision];
        }
        if (!this.provisionAgreementsFilters?.agreements?.includes(agrObject.agreement)) {
            !!this.provisionAgreementsFilters.agreements
                ?
                this.provisionAgreementsFilters.agreements.push(agrObject.agreement)
                :
                this.provisionAgreementsFilters.agreements = [agrObject.agreement];
        }
        if (!this.provisionAgreementsFilters?.provisionFees?.some(pF => pF.id == agrObject?.provisionFee)) {
            let provFee = this.allProvisionsWithoutFilter.flatMap(prov => prov.provisionFees).find(pF => pF.id == agrObject?.provisionFee);
            !!this.provisionAgreementsFilters.provisionFees
                ?
                this.provisionAgreementsFilters.provisionFees.push(provFee)
                :
                this.provisionAgreementsFilters.provisionFees = [provFee]
        }
        this.expandedProvision = agrObject?.agreement?.provision;
        this.refreshViewFiltered();
    }

    suscribeToFilters() {
        this._filtersOnProvision = this.provisionsFacade.getFiltersOnProvisions$().subscribe((filters) => {
            if (!!filters) {
                this.provisionAgreementsFilters = filters;
                this.provisionsCount(filters);
                this.provisionsSuppliesCount(filters);
                this.ordersCount(filters);
                // this.modulesCount(filters);
                this.onFilterAttentions(filters);
            } else {
                this.provisionAgreementsFilters = {};
            }
        })
    }

    onFilterAttentions(filters: ProvisionAgreementFilters) {
        // Execute the potentially-expensive mamushkaCheckBoxes outside Angular's
        // zone so it doesn't block change detection or cause ExpressionChangedAfterItHasBeenCheckedError.
        // NOTE: Solo actualizamos la variable local, sin modificar el state global
        // para evitar perder attentions al momento de crear pedidos.
        try {
            // Prestaciones necesita partir del dataset completo para no arrastrar
            // recortes de vistas previas. Módulos, en cambio, usa la colección
            // activa compuesta para ese flujo.
            const source = filters?.modulesFlow
                ? (this.attentionsFacade.getAttentionsCaseActive() ?? this.attentionsFacade.getAttentions() ?? [])
                : (this.attentionsFacade.getAttentions() ?? this.attentionsFacade.getAttentionsCaseActive() ?? []);
            this.ngZone.runOutsideAngular(() => {
                // if (filters.modulesFlow) {
                //     const filtered = this.attentionsService.mamushkaCheckBoxesV2(filters, source || []);
                //     this.ngZone.run(() => {
                //         this.attentionsCaseActive = filtered;
                //     });
                // } else if (this.selectedOption === OPTIONS.ORDER) {
                //     // Para la pestaña ORDERS, no filtrar aquí - dejar que schedule-case haga el filtrado
                //     // mamushkaCheckBoxes no maneja orders, solo provisionFees
                //     setTimeout(() => {
                //         this.ngZone.run(() => {
                //             this.attentionsCaseActive = source;
                //         });
                //     }, 0);
                // } else {
                const filtered = this.attentionsService.mamushkaCheckBoxes(filters, source || []);
                // Bring the result back into Angular on the next tick so change detection
                // can run cleanly and we avoid ExpressionChangedAfterItHasBeenCheckedError.
                setTimeout(() => {
                    this.ngZone.run(() => {
                        this.attentionsCaseActive = filtered;
                    });
                }, 0);
                // }

            });
        } catch (err) {
            // Fallback to synchronous call if anything goes wrong
            const filtered = this.attentionsService.mamushkaCheckBoxes(filters, this.attentionsFacade.getAttentions());
            this.attentionsCaseActive = filtered;
        }
    }

    provisionsCount(filters: ProvisionAgreementFilters) {
        // if (filters?.modulesFlow) {
        //     this.provisionsFilteredCount = 0;
        //     return;
        // }
        this.provisionsFilteredCount = filters?.provisionFees?.filter(pF => !this.allProvisionsWithoutFilter.find(prov => prov.id == pF.provisionId).isSupply).length;
    }

    provisionsSuppliesCount(filters: ProvisionAgreementFilters) {
        this.provisionsSuppliesFilteredCount = filters?.provisionsSupplies?.length;
    }

    ordersCount(filters: ProvisionAgreementFilters) {
        this.ordersFilteredCount = filters?.orders?.length;
    }

    // modulesCount(filters: ProvisionAgreementFilters) {
    //     if (filters?.modulesFlow) {
    //         const practicesCount = filters?.provisionFees?.length ?? 0;
    //         const caseModulesCount = filters?.caseModuleIds?.length ?? 0;
    //         this.modulesFilteredCount = practicesCount + caseModulesCount;
    //     } else {
    //         this.modulesFilteredCount = 0;
    //     }
    // }

    // onSelectedCaseModuleIdsChanged(ids: number[]): void {
    //     this.selectedCaseModuleIds = Array.isArray(ids) ? ids : [];
    // }

    removeFilters() {
        const provisionAgreementsFilters: ProvisionAgreementFilters = {
            provisions: [],
            provisionFees: [],
            agreements: [],
            provisionsSupplies: [],
            provisionAgreementsSupplies: [],
            orders: [],
        } as ProvisionAgreementFilters;

        // Update internal counters
        this.provisionsCount(provisionAgreementsFilters);
        this.provisionsSuppliesCount(provisionAgreementsFilters);
        this.ordersCount(provisionAgreementsFilters);
        // this.modulesCount(provisionAgreementsFilters);

        // Push empty filters to the facade so that other parts of the UI update
        // Use forceImmediate to avoid races with other components that may
        // re-emit based on their internal selections in the same macrotask.
        this.provisionsFacade.setFiltersOnProvisions({ ...provisionAgreementsFilters });

        // Reset the attentions view immediately so switching views shows an
        // unfiltered list (prevents leftover filters from hiding attentions).
        this.onFilterAttentions(provisionAgreementsFilters);
    }

    calculateView() {
        if (this.jumpToScreen) {
            return 'listado'
        } else {
            return (!!this.viewColumnsBillAndDebit) ? "listado" : "calendario";
        }
    }

    mustShowSpinner() {
        if (this.isCollapsedView) {
            if (this.isLoadingGetAttentions || this.isLoadingGettingEvolutions) {
                return true;
            }
        }
        return false;
    }

    linkToConsolidation() {
        let patient = { ...this.case.patient };
        patient.id = this.case.patientId; // Replace case.patient.id with case.patientId else Consolidation doesn't work
        this.router.navigate([ROUTES.CONSOLIDATION], { state: { patient: patient, financier: this.case.financier, dateSelectedFrom: moment(this.dateRange.historyFromDate).format('YYYY-MM-DD'), dateSelectedTo: moment(this.dateRange.historyToDate).format('YYYY-MM-DD') } });
    }

    refreshViewFiltered() {
        this.provisionsFacade.setFiltersOnProvisions(this.provisionAgreementsFilters);
    }

    // Open component app-supply-list.this.openAddSupplyDialog( 'FPR', __ ) for update provisionFees if have Kairos checked
    openModifyProvisionFeeSupplies(provisionFeeIds: number[]) {
        this.provisionsFeeIdsToModifySupplies = provisionFeeIds; // Input in supply-list
    }

    //Opens component app-schedule-case.onClickFacturableDebitada() to bill items attentions
    billModifiedAttentions(suppliesToModifyAttentions: number[]) {
        this.billModifiedSupplies = suppliesToModifyAttentions; //Input on schedule-case. Executes ngOnChanges
    }


    handleEvent(event: ViewManagementEntities) {
        switch (event) {
            case ViewManagementEntities.PRACTICES_WITHOUT_SCHEDULE:
                this.closePanel();
                this.onFlowSelectOption('PROVISION');
                break;
            case ViewManagementEntities.ATTENTIONS_OLD_AND_OMITTED:
                this.jumpToScreen = true;
                this.onFlowSelectOption('PROVISION');
                this.viewColumnsBillAndDebit = false;
                this.visibleCalendarPanel = true;
                this.visibleEvolution = false;
                this.isCollapsedView = true;
                this.showCalendarList = true;
                break;
            case ViewManagementEntities.ATTENTIONS_WITHOUT_BILLING:
                this.jumpToScreen = true;
                this.onFlowSelectOption('PROVISION');
                this.visibleCalendarPanel = true;
                this.visibleEvolution = false;
                this.isCollapsedView = true;
                this.showCalendarList = true;
                this.viewColumnsBillAndDebit = true;
                break;
            case ViewManagementEntities.BILLING_ATTENTIONS:
                this.onFlowSelectOption('PROVISION');
                this.linkToConsolidation();

                break;
            case ViewManagementEntities.SUPPLIES_WITHOUT_ORDER:
                this.closePanel();
                this.onFlowSelectOption('SUPPLY');
                break;
            case ViewManagementEntities.SUPPLIES_NOT_DELIVERED:
                this.closePanel();
                this.onFlowSelectOption('SUPPLY');
                break;
            case ViewManagementEntities.SUPPLIES_NOT_BILLING:
                this.onFlowSelectOption('SUPPLY');
                this.onClickBilling();
                break;
            case ViewManagementEntities.SUPPLIES_NOT_INFORMED:
                this.onFlowSelectOption('SUPPLY');
                this.linkToConsolidation();
                break;
            default: null
        }
    }

    //MODULES

    expandProvisions(provisions: Provision[]): Provision[] {
        return provisions.flatMap((prov) => {
            const fees = prov.provisionFees ?? [];
            return fees.map((pF) => ({
                ...prov,
                provisionFeeId: pF.id,
                provisionFees: [pF],
            }));
        });
    }

    // getModuleName(id: number): string {
    //     const module = this.modulesFilteredByFinancier?.find(m => m.id === id);
    //     return module?.name ?? '';
    // }

    keepAgreementMatchingProvisionFeeId(prov: Provision): Provision {
        const provisionFeeId = prov?.provisionFeeId;

        // si no hay provisionFeeId o agreements, devolvemos igual (pero normalizamos agreements a array)
        const agreements = Array.isArray(prov?.agreements) ? prov.agreements : [];

        if (provisionFeeId == null) {
            return { ...prov, agreements };
        }

        const match = agreements.find(a => a?.provisionFeeId === provisionFeeId);

        return {
            ...prov,
            agreements: match ? [match] : [], // si no encuentra, queda vacío
        };
    }

    // getCaseModuleProvisions(caseModuleId: number): Provision[] {
    //     const provisions = this.allProvisionsInCaseModules.flatMap((prov) => {
    //         const matchedFees = prov.provisionFees.filter(
    //             (pF) => pF.caseModuleId === caseModuleId
    //         );

    //         return matchedFees.map((pF) => {
    //             const provisionCopy: Provision = {
    //                 ...prov,
    //                 provisionFees: [pF],      // solo este fee
    //                 provisionFeeId: pF.id,    // <- clave para que el match sea contra este fee
    //             };

    //             return provisionCopy;
    //         });
    //     });

    //     return provisions.map(p =>
    //         p?.isSupply ? this.keepAgreementMatchingProvisionFeeId(p) : p
    //     );
    // }

    // castCaseModulesAndProvisionsToModules(): CaseModuleComposed[] {
    //     let caseModulesWithProvisions: CaseModuleComposed[] = [];
    //     this.caseModules.forEach(cM => {
    //         let newModule: CaseModuleComposed;
    //         newModule = {
    //             id: cM.id,
    //             name: this.getModuleName(cM.moduleId),
    //             selected: false,
    //             frequency: this.formatCaseModuleFrequency(cM),
    //             fee: cM.fee,
    //             scheduled: 0,
    //             moduleId: cM.moduleId,
    //             billed: 0,
    //             debited: 0,
    //             informed: 0,
    //             provisions: this.getCaseModuleProvisions(cM.id),
    //             vigency: moment(cM.fromDate).format('DD/MM/YYYY') + ' - ' + (cM.toDate ? moment(cM.toDate).format('DD/MM/YYYY') : ''),
    //             authorization: !!cM.authorization ? cM.authorization : null,
    //             fromDate: cM.fromDate,
    //             toDate: cM.toDate
    //         }
    //         caseModulesWithProvisions.push(newModule);
    //     })
    //     return caseModulesWithProvisions;
    // }

    // private normalizeCaseModuleFrequencyUnit(unitRaw: any): string | null {
    //     if (unitRaw == null) return null;

    //     // Si viene como string, lo mostramos tal cual.
    //     if (typeof unitRaw === 'string') {
    //         const u = unitRaw.trim();
    //         return u ? u : null;
    //     }

    //     // Si viene numérico (legacy), mapeo común.
    //     const n = Number(unitRaw);
    //     if (!Number.isFinite(n)) return String(unitRaw);

    //     // Mapeos comunes: 0/1/2 o 1/2/3
    //     const byZeroBased: Record<number, string> = { 0: 'día', 1: 'semana', 2: 'mes' };
    //     const byOneBased: Record<number, string> = { 1: 'día', 2: 'semana', 3: 'mes' };

    //     return byZeroBased[n] ?? byOneBased[n] ?? String(unitRaw);
    // }

    // private formatCaseModuleFrequency(cm: CaseModule): string {
    //     let amount = cm.frequency?.amount;
    //     let unit = cm.frequency.unit;
    //     if (amount == null || unit == null) return '-';
    //     if (amount < 1 || unit.length === 0) return '-';
    //     let frequency = `${amount} por  ${(unit)}`;
    //     return frequency
    // }

    // getCaseModulesProvisionFeesWithPractices(): ProvisionFeeWithPractice[] {
    //     let provisionFeesWithPractices: ProvisionFeeWithPractice[] = [];
    //     this.caseModulesComposed.forEach(cM => {
    //         cM.provisions.forEach(prov => {
    //             prov.provisionFees.forEach(pF => {
    //                 provisionFeesWithPractices.push({
    //                     ...pF,
    //                     practice: prov.practice
    //                 } as ProvisionFeeWithPractice)
    //             })
    //         })
    //     })
    //     this.provisionFeesWithPractices = provisionFeesWithPractices;
    //     return provisionFeesWithPractices;
    // }

    // Single Module Selector Handler:
    // onSingleSelectedModuleChanged(module: { id: number | null, name: string | null }): void {
    //     this.singleSelectedCaseModule = module;
    // }

    // Orders Radio Handler:
    onOrdersRadioSelectedChanged(selected: boolean): void {
        this.ordersRadioSelected = selected;
    }
}

